const toolsDefinition = [
  // {
  //   name: "focus_planet",
  //   description: "Focus on a specific planet, when the user is asking about it",
  //   parameters: {
  //     type: "object",
  //     properties: {
  //       planet: {
  //         type: "string",
  //         description: "The name of the planet to focus on",
  //       },
  //     },
  //     required: ["planet"],
  //   },
  // },
  // {
  //   name: "display_data",
  //   description:
  //     "Display a chart to summarize the answer with data points. Respond to the user before calling this tool, and call this as soon as there is numeric data to be displayed.",
  //   parameters: {
  //     type: "object",
  //     properties: {
  //       chart: {
  //         type: "string",
  //         enum: ["bar", "pie"],
  //         description: "The most appropriate chart to use",
  //       },
  //       title: {
  //         type: "string",
  //         description:
  //           "The title of the response that will be displayed above the chart, be concise",
  //       },
  //       text: {
  //         type: "string",
  //         description:
  //           "Optional text to display above the chart for more context, empty if unnecessary",
  //       },
  //       data: {
  //         type: "array",
  //         description: "data to display in the component, empty array if N/A",
  //         items: {
  //           type: "object",
  //           properties: {
  //             label: {
  //               type: "string",
  //               description: "Data item label",
  //             },
  //             value: {
  //               type: "string",
  //               description: "Data item value",
  //             },
  //           },
  //           required: ["label", "value"],
  //           additionalProperties: false,
  //         },
  //       },
  //     },
  //   },
  // },
  // {
  //   name: "reset_camera",
  //   description:
  //     "When the user says that they're done, for example 'thank you, i'm ok', zoom out of a planet focus and reset the camera to the initial position",
  //   parameters: {},
  // },
  // {
  //   name: "show_orbit",
  //   description:
  //     "Show planets orbits when there's a question related to to the position of the planet in the solar system",
  //   parameters: {},
  // },
  // {
  //   name: "show_moons",
  //   description: "Show a list of moons",
  //   parameters: {
  //     type: "object",
  //     properties: {
  //       moons: {
  //         type: "array",
  //         items: {
  //           type: "string",
  //         },
  //       },
  //     },
  //     required: ["moons"],
  //   },
  // },
  // {
  //   name: "get_iss_position",
  //   description: "Get the ISS position and once you have it, say it out loud",
  //   parameters: {},
  // },
  {
    name: "interview_finished",
    description: "Indicate that the interview is finished. Call this tool when the interview is done and you said goodbye.",
    parameters: { type: "object", properties: {} },
  },
  {
    name: "part_finished",
    description: "Indicate that the interview part is finished. Call this tool when the interview part is done.",
    parameters: { type: "object", properties: {} },
  },
];

export const TOOLS = toolsDefinition.map((tool) => ({
  type: "function",
  ...tool,
}));
